"use client";

import { motion } from "framer-motion";

const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

export const AnimatedSection = ({ children }: { children: React.ReactNode }) => {
    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            variants={ sectionVariants }
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
        >
            {children}
        </motion.div>
    );
};